module.exports = require('./helpers/bundle-url').getBundleURL('HuwXZ') + "logo.c51670a8.svg";